import React from "react";
import { MyTooltip } from "../tooltip/Tooltip";
import { TExportDestinations } from "@src/store/system/listExportDestinationsSlice";
import { Button, ButtonVariant } from "../button/Button";
import { MarketplaceIcon } from "../marketPlaces/MarketplaceIcon";
import styles from "./DisplayMarketplace.module.scss";

type TDisplayMarketplace = {
	data: TExportDestinations;
	disableTooltip?: boolean;
};

const DisplayMarketplace = ({ data, disableTooltip }: TDisplayMarketplace) => {
	const element = (
		<Button style={{ padding: 6 }} variant={ButtonVariant.Secondary} key={data.Export_Destination_ID}>
			<div className={styles.imageContainer}>
				<MarketplaceIcon destination={data} />
			</div>
		</Button>
	);

	if (disableTooltip) return element;

	return (
		<MyTooltip
			key={data.Export_Destination_ID}
			id={`tooltip_${data.Export_Destination_ID}`}
			popup={data.Exchange_Name}
			elementStyle={{ padding: 6 }}
			element={element}
		/>
	);
};

export default DisplayMarketplace;
